module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "show": _vm.showModal
    },
    on: {
      "close": _vm.setCloseModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('vue2.createusers.create_users')))]), _vm._v(" "), _c('div', {
    staticClass: "cu",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "cu-tab-content"
  }, [_c('createUserForm', {
    attrs: {
      "country": _vm.country,
      "pushname": _vm.pushNameFromSelect2
    },
    on: {
      "editedUsers": _vm.setUsers,
      "onNameInput": _vm.checkForDoubleNames
    }
  }), _vm._v(" "), (_vm.isTestSchool) ? _c('SearchForCalendar', {
    staticStyle: {
      "border-top": "1rem solid #edf0f5"
    },
    attrs: {
      "query": _vm.activeInputName,
      "calendarType": "users"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "flex flex-end pad-10",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showInactiveButton) ? _c('button', {
    staticClass: "create-form__submit"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.createusers.create')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.usersToSubmit.length > 0) ? _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.submitUsers
    }
  }, [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dbf319dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateCalendars/CreateUser/CreateUser.vue
// module id = 1758
// module chunks = 1